module.exports = __webpack_public_path__ + "static/media/evolving-sol-dark-mode.1c7a5db0.png";